import { TRADE_IN_PAGE_SLUG } from 'store/SharedZone/constants';

export const SET_MAP_POINTS = 'Widget::OfficesMap::Set::Points';
export const SET_MAP_POINTS_IS_FETCHED = 'Widget::OfficesMap::Set::PointsFetched';
export const SET_MAP_POINTS_SEARCH_QUERY = 'Widget::OfficesMap::Set::SearchQuery';

/* import needed section/page slug and use it through this selector */
export const getPointsUrlsBySlug = {
  [TRADE_IN_PAGE_SLUG]: '/shop/trade-in/getpointsbypayment/',
};
